import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface ScrollProps {
	children: JSX.Element;
}

const ScrollToTop = ({ children }: ScrollProps): JSX.Element => {
	const { pathname } = useLocation();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);

	return children;
};

export default ScrollToTop;
